import request from "@/utils/request";
import {deleteUser} from "@/apis/UserApi";


/**
 * [查询][列表]获取客户信息列表
 */
export const getCustomerList = () => {
    return request.get(`/customer/list`);
}
/**
 * [查询][分页]获取客户信息列表
 * @param params     查询条件
 */
export const getCustomerPage = (params) => {
    return request.get(`/customer/page`, { params });
}

// --------------------- 客户账号 ---------------------

/**
 * [查询][列表]获取客户账号列表
 */
export const getCustomerAccountList = () => {
    return request.get(`/customerAccount/list`);
}
/**
 * [查询][分页]获取客户账号列表
 * @param params     查询条件
 */
export const getCustomerAccountPage = (params) => {
    return request.get(`/customerAccount/page`, { params });
}
/**
 * [查询]获取单个客户账号详情
 * @param id     客户账号id
 */
export const getCustomerAccountInfo = (id) => {
    return request.get(`/customerAccount/info/${id}`);
}

/**
 * [查询]获取单个客户账号信息，包括账号对应的[客户信息列表]+[门店信息列表]
 * @param id     客户账号id
 */
export const getCustomerAccount = (id) => {
    return request.get(`/customerAccount/${id}`);
}

/**
 * [新增]添加客户账号
 * @param data   客户账号数据
 */
export const addCustomerAccount = (data) => {
    return request.post(`/customerAccount`, data);
}

/**
 * [修改]更新客户账号
 * @param data   客户账号数据
 */
export const updateCustomerAccount = (data) => {
    return request.put(`/customerAccount`, data);
}

/**
 * [删除]删除客户账号
 * @param id     客户账号id
 */
export const deleteCustomerAccount = (id) => {
    return request.delete(`/customerAccount/${id}`);
}
/**
 * [导出]导出客户账号数据
 * @param params 导出参数 (如果为空则导出全部)
 */
export const exportCustomerAccount = (params) => {
    return request.post(`/customerAccount/export`, params, {
        responseType: 'blob'
    });
}

/**
 * [导入]导入客户账号数据
 * @param file   Excel文件
 */
export const importCustomerAccount = (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return request.post(`/customerAccount/import`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

/**
 * [下载]下载客户账号导入模板
 */
export const downloadCustomerAccountTemplate = () => {
    return request.get(`/customerAccount/template`, {
        responseType: 'blob'
    });
}

// --------------------- 公司抬头信息 ---------------------

/**
 * [查询][分页]获取公司抬头信息列表
 * @param params     查询条件
 */
export const getCustomerCompanyHeaderPage = (params) => {
    return request.get(`/customerCompanyHeader/page`, { params });
}

// --------------------- 门店信息 ---------------------

/**
 * [查询][列表]获取门店信息列表
 */
export const getCustomerStoreList = () => {
    return request.get(`/customerStore/list`);
}
/**
 * [查询][分页]获取门店信息列表
 * @param params     查询条件
 */
export const getCustomerStorePage = (params) => {
    return request.get(`/customerStore/page`, { params });
}

/**
 * [查询][分页]获取门店类型列表
 * @param params     查询条件
 */
export const getCustomerStoreTypePage = (params) => {
    return request.get(`/customerStoreType/page`, { params });
}

/**
 * [新增]添加客户账号关联的客户信息
 * @param accountId     客户账号ID
 * @param customerIds   客户ID数组
 */
export const addAccountCustomerRelation = (accountId, customerIds) => {
    return request.post(`/customerAccountRelation/accountId/${accountId}/customer`, { ids: customerIds });
}

/**
 * [新增]添加客户账号关联的门店信息
 * @param accountId     客户账号ID
 * @param storeIds      门店ID数组
 */
export const addAccountStoreRelation = (accountId, storeIds) => {
    return request.post(`/customerAccountRelation/accountId/${accountId}/store`, { ids: storeIds });
}

/**
 * [删除]删除客户账号关联表单条记录
 * @param relationId    关联表ID
 */
export const deleteOneRelation = (relationId) => {
    return request.delete(`/customerAccountRelation/${relationId}`);
}